export default __webpack_public_path__ + "static/media/werewolves-close-eyes.a8334ca3.mp3";